import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

import Item from './Item';

export type ItemTypes = {
  title?: string;
  path: string;
  icon: React.ReactNode;
  childs?: ItemTypes[];
};

type Props = {
  onClickCallback?: () => void;
  data: ItemTypes & {
    childs?: ItemTypes[];
  };
};

const MenuItems: React.FC<Props> = ({ data, onClickCallback }) => {
  const { childs } = data;
  const location = useLocation();

  const haveChild = childs && childs.length > 0;
  const isCurrentMenu = useMemo(() => {
    const isPathMatched = (path?: string) => {
      if (!path) return false;

      return (
        location.pathname === path || location.pathname.startsWith(`${path}/`)
      );
    };

    return (
      isPathMatched(data.path) ||
      (childs || []).some((child) => isPathMatched(child.path))
    );
  }, [childs, data.path, location.pathname]);

  const [isOpen, setIsOpen] = useState(isCurrentMenu);
  const previousPathname = useRef(location.pathname);

  useEffect(() => {
    if (previousPathname.current !== location.pathname && isCurrentMenu) {
      setIsOpen(true);
    }
    previousPathname.current = location.pathname;
  }, [isCurrentMenu, location.pathname]);

  const handleToggle = () => {
    setIsOpen((prev) => !prev);
  };

  return (
    <>
      {haveChild ? (
        <div className={`dropdown ${isOpen ? 'open' : ''}`}>
          <Item
            key={data.path}
            data={data}
            onClickCallback={() => {
              handleToggle();
              // onClickCallback?.();
            }}
            haveChild
          />

          <div className='dropdown-menu-wrapper'>
            {childs.map((child: ItemTypes) => {
              return (
                <Item
                  key={child.path}
                  data={child}
                  onClickCallback={onClickCallback}
                />
              );
            })}
          </div>
        </div>
      ) : (
        <Item key={data.path} data={data} onClickCallback={onClickCallback} />
      )}
    </>
  );
};

export default MenuItems;
